import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { authenticateByPhone } from "@/api/auth";
import cls from "./styles.module.scss";
import {
  extractPhoneDigits,
  formatPhoneDigits,
  normalizePhoneForSubmit,
} from "./phoneUtils";

export default function PhoneLoginForm({
  onAuthorized,
}: {
  onAuthorized: (session: { token: string; telegram_id: number }) => void;
}) {
  const { t } = useTranslation();
  const [phoneDigits, setPhoneDigits] = useState("");
  const [phoneLoading, setPhoneLoading] = useState(false);
  const [phoneTouched, setPhoneTouched] = useState(false);

  const phoneState = formatPhoneDigits(phoneDigits);
  const phoneError =
    phoneTouched && !phoneState.valid && phoneDigits.length > 0;

  const loginByPhone = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setPhoneTouched(true);

    const normalizedPhone = normalizePhoneForSubmit(phoneDigits);
    if (phoneLoading || !normalizedPhone) return;

    try {
      setPhoneLoading(true);
      const session = await authenticateByPhone(normalizedPhone);
      onAuthorized(session);
    } catch (err) {
      console.error("Failed to authenticate by phone:", err);
    } finally {
      setPhoneLoading(false);
    }
  };

  return (
    <form className={cls.phoneForm} onSubmit={loginByPhone}>
      <label className={cls.fieldLabel} htmlFor="phone-auth-input">
        {t("authRequired.phoneLabel")}
      </label>
      <div
        className={`${cls.phoneInput} ${
          phoneError ? cls.phoneInputInvalid : ""
        }`}
      >
        <span className={cls.flag} aria-hidden="true">
          🇷🇺
        </span>
        <input
          id="phone-auth-input"
          type="tel"
          inputMode="numeric"
          autoComplete="tel"
          value={phoneState.formatted}
          onChange={(event) =>
            setPhoneDigits(extractPhoneDigits(event.target.value))}
          onBlur={() => setPhoneTouched(true)}
          placeholder={t("authRequired.phonePlaceholder")}
        />
      </div>
      <p
        className={`${cls.phoneHint} ${phoneError ? cls.phoneHintVisible : ""}`}
      >
        {t("authRequired.phoneHint")}
      </p>
      <button
        className={`${cls.btn} ${cls.btnPrimary}`}
        type="submit"
        disabled={!phoneState.valid || phoneLoading}
      >
        {phoneLoading ? <span className={cls.spinner} /> : null}
        {t("authRequired.phoneButton")}
      </button>
    </form>
  );
}
